import React from 'react';
import { Book, MessageSquare, Info } from 'lucide-react';

interface WordInfo {
    definition: string;
    partOfSpeech: string;
    explanation: string;
    audio: string;
}

interface DictionaryType {
    [key: string]: WordInfo;
}

const WordInfoCard: React.FC<{ word: string } & Omit<WordInfo, 'audio'>> = ({ word, definition, partOfSpeech, explanation }) => {
    return (
        <div className="bg-white shadow-lg rounded-lg overflow-hidden h-full">
            <div className="bg-blue-500 p-4">
                <h2 className="text-xl font-bold text-white">{word}</h2>
            </div>
            <div className="p-4 space-y-4">
                <div className="flex items-start">
                    <Book className="w-5 h-5 mr-2 text-blue-500" />
                    <div>
                        <h3 className="text-md font-semibold">Definition</h3>
                        <p className="text-sm">{definition}</p>
                    </div>
                </div>
                <div className="flex items-start">
                    <MessageSquare className="w-5 h-5 mr-2 text-blue-500" />
                    <div>
                        <h3 className="text-md font-semibold">Part of Speech</h3>
                        <p className="text-sm">{partOfSpeech}</p>
                    </div>
                </div>
                <div className="flex items-start">
                    <Info className="w-5 h-5 mr-2 text-blue-500" />
                    <div>
                        <h3 className="text-md font-semibold">Explanation</h3>
                        <p className="text-sm whitespace-pre-wrap">{explanation}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const WordInfoGridPage: React.FC<{ dictionary: DictionaryType }> = ({ dictionary }) => {
    return (
        <div className="container mx-auto p-4">
            <h1 className="text-3xl text-center font-bold mb-6">Greek Dictionary</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {Object.entries(dictionary).map(([word, info]) => (
                    <WordInfoCard
                        key={word}
                        word={word}
                        definition={info.definition}
                        partOfSpeech={info.partOfSpeech}
                        explanation={info.explanation}
                    />
                ))}
            </div>
        </div>
    );
};

export default WordInfoGridPage;